export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface DocumentSortFilterType {
  sortOption: SortFilterOption<server.dto.DocumentSort>
}

const getPermissionForDocumentType = (documentType: server.dto.DocumentTypes) => {
  switch (documentType) {
    case "contract":
      return site.permissions.contract;
    case "quote":
      return site.permissions.quote;
    case "purchaseAgreement":
      return site.permissions.purchaseAgreement;
    default:
      return site.permissions.quote;
  }
};

export const getDocumentSortOptions = (documentType: server.dto.DocumentTypes): Array<SortFilterOption<server.dto.DocumentSort>> => ([
  {
    value: "documentnumber_desc",
    label: RESX.Document.DocumentNumber,
    enabled: true
  },
  {
    value: "status_asc",
    label: RESX.Status.resxStatus,
    enabled: true
  },
  {
    value: "currency_asc",
    label: RESX.Financial.Currency,
    enabled: true
  },
  {
    value: "addressee_asc",
    label: RESX.Document.Addressee,
    enabled: true
  },
  {
    value: "senddate_asc",
    label: RESX.DateTime.SendDate,
    enabled: true
  },
  {
    value: "duedate_desc",
    label: RESX.DateTime.DueDate,
    enabled: true
  },
  {
    value: "sales_desc",
    label: RESX.Financial.Sales,
    enabled: getPermissionForDocumentType(documentType).canReadSales
  },
  {
    value: "lastmodified_desc",
    label: RESX.GeneralLabels.LastModified,
    enabled: true
  }
]);

export const DefaultDocumentSortFilter: server.dto.DocumentSort = "documentnumber_desc";

export const getDocumentSortOptionFunc = (documentType: server.dto.DocumentTypes) => {
  return (value: server.dto.DocumentSort) => {
    if (value === "documentnumber_desc") return getDocumentSortOptions(documentType)[0];
    return getDocumentSortOptions(documentType).find((s) => s.value === value);
  };
};

export const initialDocumentSortFilter: DocumentSortFilterType = {
  sortOption: {
    value: "documentnumber_desc",
    label: RESX.Document.DocumentNumber,
    enabled: true
  }
};
